import type { Theme } from '@mui/material/styles'

/**
 * MUI `sx` treats numeric `borderRadius` as a multiplier of `theme.shape.borderRadius`
 * (e.g. `8` with shape 8 → 64px). Use this for a literal corner radius in px.
 */
export function shapeBorderRadiusPx(theme: Theme): string {
  return `${theme.shape.borderRadius}px`
}
